<template>
  <div class="inputs">
    <eco-select
      style="width:100%;"
      @click.native="clickNative"
      :validate="validate"
      :options="options"
      :name="inputName"
      v-model="inputVal"
      size="small"
      clearable
      :placeholder="placeholder"
      :filterable="filterable"
      :allow-create="allowCreate"
      reserve-keyword
      :multiple="multiple"
      :linkage="linkage"
      ref="selected"
      @blur="selectBlur"
      :disabled="!isEdit"
      :permission="permission"
    >
      <template>
        <el-option
          v-for="item in this.options"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        ></el-option>
        <div
          v-if="this.config && this.config.needPage === 1"
          class="text-center"
          style="position: sticky;background: #fff;height:30px;top:0;z-index:1"
        >
          <a class="text-normal">
            <el-pagination
              class="pagination"
              :page-sizes="[5]"
              layout="prev, next"
              @current-change="handleCurrentChange"
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
            />
          </a>
        </div>
      </template>
    </eco-select>
  </div>
</template>
<script>
import utils from "@/utils.js";
import ecoUtils from "@/eco-ui-util.js";
import req from "@/request.js";
import _ from "lodash";
export default {
  name: "eip-select",
  props: [
    "validate",
    "value",
    "name",
    "permission",
    "multiple",
    "selectlist",
    "linkage",
    "ganged",
    "filterable",
    "allowCreate",
    "placeholder",
    "configAttributes",
    "customQuery"
  ],
  data() {
    return {
      inputValnew: "",
      config: {},
      isEdit: false,
      total: 10,
      pageSize: 5,
      currentPage: 1,
      options: [],
      newValidate: null,
      curSubIndex: null
    };
  },
  computed: {
    inputVal: {
      get: function() {
        if (this.value || this.value === 0) {
          return this.value + "";
        }
        return this.value;
      },
      set: function(val) {
        this.$emit("input", val);
        if (!this.multiple && val) {
          //判断对话框是否绑定了关联查询
          let custQueryJson = this.customQuery.custQueryJson;
          if (custQueryJson.length > 0) {
            for (let i = 0; i < custQueryJson.length; i++) {
              if (custQueryJson[i].conditionfield.length > 0) {
                this.doQuery(custQueryJson[i]);
              } else {
                console.error(
                  "[" +
                    custQueryJson[i].comment +
                    "]关联查询取值参数未绑定表单字段"
                );
              }
            }
          }
        }
      }
    },
    inputWriteable: function() {
      return utils.getWriteable(this.permission);
    },
    inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      var validateObj = this.$store.state.index.validate;
      return utils.addRequiredOrNot(
        this.permission,
        this.validate,
        validateObj,
        this
      );
    },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    }
  },
  mounted() {
    this.options = this.selectlist ? this.selectlist : [];
    if (this.configAttributes) {
      if (this.configAttributes.isInputEdit) {
        this.isEdit = !this.configAttributes.isInputEdit;
      } else {
        this.isEdit = true;
      }
    } else {
      this.isEdit = true;
    }

    const this_ = this;
    //动态传入
    if (this_.ganged && this_.ganged.alias && this_.options.length < 1) {
      this_.$store
        .dispatch("form/getByAliasCq", this_.ganged.alias)
        .then(res => {
          this_.config = res;
          this_.handelInitGangedsearch();
          this_.initGanged(true);
        });
    } else {
      this_.initGanged(false);
    }

    this_.debounceQuickSearch = _.debounce((flag, val, isInit) => {
      let param = [];
      if (this_.ganged) {
        const bind = this_.ganged.bind;
        for (let bindkey in bind) {
          const pInst = utils.getOnlineFormInstance(this_);
          const val = utils.getValueByPath(pInst, bind[bindkey]);
          if (val) {
            param.push({ key: bindkey, value: val });
          }
        }
        this_.search(flag, param, isInit);
      } else {
        this_.search(flag, val, isInit);
      }
    }, 500);

    this_.options = this_.selectlist ? this_.selectlist : [];

    //回显(固定值)
    if (
      this.inputVal &&
      this.inputVal.length > 0 &&
      this.inputValnew == "" &&
      this.selectlist
    ) {
      let inputValArr = [];
      for (var a = 0; a < this.selectlist.length; a++) {
        //多选
        if (this.inputVal instanceof Array) {
          for (var i = 0; i < this.inputVal.length; i++) {
            if (this.selectlist[a].key == this.inputVal[i]) {
              inputValArr.push(this.selectlist[a].value);
              this.inputVal[i] = this.selectlist[a].value;
              break;
            }
          }
        } else {
          //单选
          if (this.selectlist[a].key == this.inputVal) {
            inputValArr.push(this.selectlist[a].value);
            break;
          }
        }
      }
      //下拉框可创建条目 （多选）
      if (
        this.inputVal instanceof Array &&
        inputValArr.length < this.inputVal.length
      ) {
        inputValArr = [...this.inputVal];
      } else if (this.inputVal instanceof String) {
        //下拉框可创建条目 （单选）
        if (inputValArr.length == 0) {
          inputValArr.push(this.inputVal);
        }
      }
      this.inputValnew = inputValArr.join(",");
    }
  },
  created() {
    this.options = this.selectlist ? this.selectlist : [];
    let this_ = this;
    // //动态传入
    // if (this.ganged && this.ganged.alias && this.options.length < 1) {
    //   this.$store.dispatch("form/getByAliasCq", this.ganged.alias).then(res => {
    //      ;
    //     this_.config = res;
    //     if (this_.ganged && JSON.stringify(this_.ganged.bind) != "{}") {
    //       this_.handelInitGangedsearch();
    //     } else {
    //       this_.search(false, "");
    //     }
    //   });
    // }
    if (this.value.toString() && this.value.toString().indexOf("[") === 0) {
      var selectVal = this.value.substr(0, this.value.length - 1);
      selectVal = selectVal.substr(1);
      if (selectVal === "") {
        this.inputVal = selectVal;
        return;
      }
      var selectVal2 = selectVal.split(",");
      var selectValnew = [];
      for (var i = 0; i < selectVal2.length; i++) {
        selectValnew.push(selectVal2[i].trim());
      }
      this.inputVal = selectValnew;
    } else {
      this.inputVal = this.value;
    }
    // this.$validator = this.$root.$validator;
  },
  methods: {
    initGanged(flag) {
      const _me = this;
      let { subScopeEl } = ecoUtils.getSubScopeElAndIndex(_me.$el);
      if (subScopeEl) {
        this.curSubIndex = subScopeEl.dataset["index"];
      }
      const ganged = this.ganged;
      //判断是否有参数绑定
      if (
        ganged &&
        ganged.bind &&
        JSON.stringify(ganged.bind) != "{}" &&
        this.config
      ) {
        const bind = ganged.bind;
        const formVm = utils.getOnlineFormInstance(_me);
        for (var key in bind) {
          let paramDom = null;
          if (this.curSubIndex == null) {
            paramDom = document.querySelector(
              '[model-name="' + bind[key] + '"]'
            );
          } else {
            let subFiledName = bind[key].split(".")[3];
            paramDom = subScopeEl.querySelector(
              '[model-name="item.' + subFiledName + '"]'
            );
          }
          //如果没有获取到父级联动的dom树,并且绑定的父级参数中不包含sub字段,则说明是子表联动主表字段
          if (!paramDom && bind[key].indexOf(".sub_") == -1) {
            paramDom = document.querySelector(
              '[model-name="' + bind[key] + '"]'
            );
          }
          if (paramDom && paramDom.__vue__) {
            paramDom.__vue__.$watch("value", function(newVal, oldVal) {
              if (newVal != oldVal) {
                if (_me.config.dsType == "dataSource") {
                  var param = [];
                  for (var bindkey in bind) {
                    if (newVal) {
                      param.push({ key: bindkey, value: newVal });
                    }
                  }
                  _me.debounceQuickSearch(false, param, true);
                } else {
                  _me.debounceQuickSearch(false, newVal, true);
                }
              }
            });
            //如果被联动的值已经有初始化值了,应该就直接拿来用
            if (flag && paramDom.__vue__.value) {
              if (_me.config.dsType == "dataSource") {
                var param = [];
                for (var bindkey in bind) {
                  if (paramDom.__vue__.value) {
                    param.push({ key: bindkey, value: paramDom.__vue__.value });
                  }
                }
                _me.debounceQuickSearch(false, param, true);
              } else {
                _me.debounceQuickSearch(false, paramDom.__vue__.value, true);
              }
            }
          }
        }
      }
    },
    async doQuery(param) {
      let paramLoadData = [];
      const pInst = utils.getOnlineFormInstance(this);
      //获取关联查询绑定的表单参数
      for (let i = 0; i < param.conditionfield.length; i++) {
        if (param.conditionfield[i].fieldPath != "") {
          let bindVal = utils.getValueByPath(
            pInst,
            param.conditionfield[i].fieldPath,
            null
          );
          let obj = { key: param.conditionfield[i].field, value: bindVal };
          paramLoadData.push(obj);
        }
      }

      let queryUrl =
        param.dsType == "dataSource"
          ? "${form}/form/customQuery/v1/doQuery?alias=" +
            param.alias +
            "&page=1"
          : param.url;
      let requestMethod = "POST";
      //如果关联数据列表查询数据不是数据源则请求方法为restful配置的请求方式
      if (param.dsType != "dataSource") {
        requestMethod = param.requestType;
      }
      //查询数据
      req
        .request({ url: queryUrl, method: requestMethod, data: paramLoadData })
        .then(res => {
          //判断是否有关联查询数据返回
          if (res.data.rows.length > 0) {
            //获取关联查询返回的表单参数
            for (let i = 0; i < param.resultfield.length; i++) {
              if (param.resultfield[i].fieldPath != "") {
                let val = "";
                for (let j = 0; j < res.data.rows.length; j++) {
                  if (res.data.rows[j][param.resultfield[i].comment]) {
                    val =
                      val +
                      res.data.rows[j][param.resultfield[i].comment] +
                      ",";
                  }
                }
                val = val.substring(0, val.length - 1);
                //赋值给绑定的字段
                utils.setValueByPath(
                  pInst,
                  param.resultfield[i].fieldPath,
                  val,
                  null
                );
              }
            }
          } else {
            //获取关联查询返回的表单参数
            for (let i = 0; i < param.resultfield.length; i++) {
              if (param.resultfield[i].fieldPath != "") {
                //赋值给绑定的字段
                utils.setValueByPath(
                  pInst,
                  param.resultfield[i].fieldPath,
                  "",
                  null
                );
              }
            }
          }
        });
    },
    handelInitGangedsearch: function() {
      const _me = this;
      let { subScopeEl } = ecoUtils.getSubScopeElAndIndex(_me.$el);
      if (subScopeEl) {
        this.curSubIndex = subScopeEl.dataset["index"];
      }
      const ganged = this.ganged;
      if (ganged && this.config) {
        const bind = ganged.bind;
        // const formVm = utils.getOnlineFormInstance(_me);
        if (this.curSubIndex == null) {
          //主表
          // for (var key in bind) {
          let param = [];
          if (_me.config.dsType == "dataSource") {
            for (let bindkey in bind) {
              const pInst = utils.getOnlineFormInstance(_me);
              const val = utils.getValueByPath(pInst, bind[bindkey]);
              if (val) {
                param.push({ key: bindkey, value: val });
              }
            }
            _me.debounceQuickSearch(false, param);
          } else {
            _me.debounceQuickSearch(false, param);
          }
          // }
        } else {
          //子表
          for (var key in bind) {
            let subFiledName = bind[key].split(".")[3];
            let paramDom = subScopeEl.querySelector(
              '[model-name="item.' + subFiledName + '"]'
            );
            if (paramDom && paramDom.__vue__ && paramDom.__vue__.value) {
              let newVal = paramDom.__vue__.value + "";
              if (_me.config.dsType == "dataSource" && newVal) {
                var param = [{ key: key, value: newVal }];
                _me.debounceQuickSearch(false, param);
              } else {
                _me.debounceQuickSearch(false, newVal);
              }
            }
          }
        }
      }
    },
    clickNative: function() {
      //动态传入
      if (this.ganged && this.ganged.alias && this.options.length < 1) {
        this.$store
          .dispatch("form/getByAliasCq", this.ganged.alias)
          .then(res => {
            this.config = res;
            this.search();
          });
      }
    },
    selectBlur: function() {
      // if (this.ganged && this.ganged.alias ){
      //   this.search();
      // }
    },
    remoteMethod: function(val) {
      if (val) {
        this.search(false, val);
      } else {
        this.param = "";
        this.search();
      }
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.search(currentPage, []);
    },
    search(currentPage, param, gangedChange) {
      if (gangedChange && this.$data.options.length != 0) {
        this.$refs.selected.clearValue();
      }
      this.options = [];
      if (
        !this.config ||
        (this.ganged.bind && JSON.stringify(this.ganged.bind) != "{}" && !param)
      )
        return;
      var str = this.config;
      const _this = this;
      var ganged = this.ganged;
      this.pageSize = str.pageSize;
      var pageBean = {
        pageBean: {
          page: currentPage ? currentPage : 1,
          pageSize: str.pageSize,
          showTotal: "true"
        }
      };
      if (param) {
        if (str.dsType == "dataSource") {
          let Base64 = require("js-base64").Base64;
          str.queryData = Base64.encode(JSON.stringify(param));
          str.currentPage = currentPage ? currentPage : 1;
        } else {
          var templatePa = this.config.dataParam;
          if (this.config.requestType == "POST" && templatePa) {
            var conditionfield = JSON.parse(str.conditionfield);
            conditionfield.forEach(ele => {
              const pInst = utils.getOnlineFormInstance(_this);
              const val = utils.getValueByPath(pInst, ganged.bind[ele.field]);
              if (val) {
                templatePa = templatePa.replace(
                  new RegExp("\\{" + ele.field + "\\}", "g"),
                  val
                );
              } else {
                templatePa = templatePa.replace(
                  new RegExp("\\{" + ele.field + "\\}", "g"),
                  param
                );
              }
            });
          }
          str.pageBean = utils.parseToJson(templatePa);
        }
      } else {
        str.pageBean = pageBean;
        str.currentPage = currentPage ? currentPage : 1;
        str.queryData = "";
      }
      //}
      //回写（动态值）
      this.$store.dispatch("form/selectQuery", str).then(res => {
        _this.total = res.total;
        _this.options = [];
        res.rows.forEach(m => {
          var option = {};
          if (_this.ganged.valueBind) {
            option.key = m[ganged.valueBind] + "";
          }
          if (_this.ganged.labelBind) {
            option.value = m[ganged.labelBind] + "";
          }
          _this.options.push(option);
        });
        let inputValArr = [];
        for (let i = 0; i < _this.options.length; i++) {
          //多选
          if (_this.inputVal.length > 0 && this.inputVal instanceof Array) {
            for (let j = 0; j < _this.inputVal.length; j++) {
              if (_this.inputVal[j] == _this.options[i].key) {
                inputValArr.push(_this.options[i].value);
                _this.inputVal[j] = _this.options[i].value;
                break;
              }
            }
          } else {
            //单选
            if (_this.inputVal == _this.options[i].key) {
              inputValArr.push(_this.options[i].value);
              break;
            }
          }
        }
        //下拉框可创建条目 （多选）
        if (
          _this.inputVal instanceof Array &&
          inputValArr.length < _this.inputVal.length
        ) {
          inputValArr = [..._this.inputVal];
        } else if (_this.inputVal instanceof String) {
          //下拉框可创建条目 （单选）
          if (inputValArr.length == 0) {
            inputValArr.push(_this.inputVal);
          }
        }
        _this.inputValnew = inputValArr.join(",");
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
